import React, {Component} from 'react';

import strings from '../../strings';

import {
	no_numbers,
	nn_numbers,
	se_numbers,
	de_numbers,
	de_numbers_child,
	de_numbers_adult,
} from './assets';
import listen from '../../assets/listen.png';

import './styles.scss';

class Test extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn_numbers;
				break;
			case 'se':
				this.assets = se_numbers;
				break;
			case 'de':
				switch (this.props.testKeyType) {
					case 'child-followup':
						this.assets = de_numbers_child;
						this.wsn_test1 = strings.wsn_test1Child;
						break;
					case 'adult-followup':
						this.assets = de_numbers_adult;
						this.wsn_test1 = strings.wsn_test1_adult;
						break;
					default:
						this.assets = de_numbers;
						this.wsn_test1 = strings.wsn_test1;
						break;
					}
				break;
			case 'no':
			default:
				this.assets = no_numbers;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
		Object.values(this.assets).forEach((audioEl) => audioEl.load());

		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
		this.assets[sound].play();
	};

	stopSounds = () => {
		for (const sound of Object.values(this.assets)) {
			sound.pause();
		}
	};

	render() {
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				<p>{this.wsn_test1}</p>
			</div>
		);
	}
}

export default Test;
